<template>
  <div class="login-warpper">
    <div class="login-box">
      <h1>社会组织人才考试系统管理后台</h1>
      <div class="login-form">
        <h3>忘记密码</h3>

        <div class="form-item">
          <div class="form-icon">
            <img src="../assets/img/yonghu.png" alt="">
          </div>
          <input type="text" placeholder="请输入用户名" v-model="account"/>
        </div>
        <div class="form-item">
          <div class="form-icon">
            <img src="../assets/img/shouji.png" alt="">
          </div>
          <input type="text" placeholder="请输入手机号" v-model="phone"/>
        </div>
        <div class="form-item">
          <div class="form-icon">
            <img src="../assets/img/yanzheng.png" alt="">
          </div>
          <input type="text" placeholder="请输入验证码" v-model="code"/>
          <el-button type="text" class="form-btn" :disabled="disabledState" @click="sendCode">{{ codeText }}</el-button>
        </div>
        <div class="form-item">
          <div class="form-icon">
            <img src="../assets/img/mima.png" alt="">
          </div>
          <input type="password" placeholder="请输入密码" v-model="pass"/>
        </div>
        <div class="form-item">
          <div class="form-icon">
            <img src="../assets/img/mima.png" alt="">
          </div>
          <input type="password" placeholder="请再次输入密码" v-model="npass"/>
        </div>
        <div class="login-btn" @click="setSubmit">确认修改</div>
        <router-link to="/login" class="to-login">返回登录</router-link>
      </div>
    </div>
    <div class="footer-warpper">
      Copyright 益魔方 <a target="_blank" href="http://beian.miit.gov.cn" class="margin-left-xs">京ICP备15038897号-3 </a>
      <img class="beian" src="http://www.beian.gov.cn/img/new/gongan.png">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214"
         class="margin-right-xs">京公网安备11010802038214号</a>
      北京易魔方科技集团有限公司 版权所有
    </div>
  </div>
</template>

<script>
import {login} from '@/api/login'

export default {
  name: "login",
  data() {
    return {
      account: '',
      phone:'',
      code: '',
      pass: '',
      npass: '',
      codeText: '获取验证码', // 验证码文字
      timer: null, // 计时器
      disabledState:true,
      sendState:false
    }
  },
  created() {

  },
  methods: {

    async sendCode(){
      if(this.sendState) return
      this.sendState = true
      let _second = 60
      this.timer = setInterval(()=>{
        _second--
        this.codeText = `${_second}秒后重新发送`
        if(_second === 0){
          clearInterval(this.timer)
          this.codeText = '重新发送'
          this.timer = null
          this.sendState = false
          this.disabledState = false
        }
      },1000)
    },


    async setSubmit() {
      if (!this.account) return this.$message.error('请输入用户名')
      if (!this.phone) return this.$message.error('请输入手机号')
      if (this.$tools.checkTel(this.phone)) return this.$message.error('手机号格式错误')
      if (!this.code) return this.$message.error('请输入验证码')
      if (!this.pass) return this.$message.error('请输入密码')
      if (this.pass.length<6) return this.$message.error('密码长度至少6位及以上')
      if (!this.npass) return this.$message.error('请确认密码')
      if (this.pass !== this.npass) return this.$message.error('两次密码不一致')
      const loading = this.$loading({
        lock: true,
        text: '登录中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let _data = await login('17736031292', '123456', 0)
      if (_data.code === 0) {
        loading.close();
        this.$router.push('/login')
      } else {
        this.$message.error(_data.msg)
      }

    }
  },
  watch:{
    phone(){
      if(!this.$tools.checkTel(this.phone)){
        this.disabledState = false
      }else{
        this.disabledState = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.footer-warpper {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.3);
  color: #fff;
  flex-shrink: 0;
  position: fixed;
  left: 0;
  bottom: 0;
  a {
    font-size: 14px;
    color: #fff;
    margin: 0 5px;
  }
  .beian {
    width: 15px;
    height: 15px;
    margin: 0 5px;
  }
}
.login-warpper {
  display: block;
  width: 100%;
  min-height: 100vh;
  background: url(../assets/img/loginbg.jpg) no-repeat;
  background-size: 100% 100%;
  padding-bottom: 60px;

  .login-box {
    display: block;
    width: 457px;
    margin: 0 auto;
    padding-top: 170px;

    h1 {
      font-size: 40px;
      line-height: 60px;
      margin-bottom: 40px;
      letter-spacing: 4px;
      color: #333333;
      text-align: center;
    }

    .login-form {
      width: 457px;
      padding: 30px;
      background: url(../assets/img/Layer7.png) #ffffff no-repeat;
      background-position: -44px -120px;
      background-size: 550px;
      box-shadow: 0px 8px 18px 0px rgba(231, 231, 231, 0.32);
      border-radius: 8px;

      h3 {
        text-align: center;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 60px;
        color: #333333;
        margin-bottom: 20px;
      }

      .form-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 398px;
        height: 48px;
        margin-bottom: 20px;
        background-color: #f5f5f5;
        border-radius: 4px;
        border: solid 1px #eeeeee;
        overflow: hidden;

        .form-icon {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 46px;
          height: 46px;
        }

        input {
          flex: 1;
          display: block;
          font-size: 16px;
          height: 46px;
          background: transparent;
        }

        .form-btn {
          padding: 0 10px;
        }

        .form-yzm {
          display: block;
          width: 120px;
          height: 46px;
        }
      }
    }

    .login-btn {
      width: 398px;
      height: 56px;
      text-align: center;
      line-height: 54px;
      font-size: 18px;
      color: #fff;
      background-color: #189f92;
      border-radius: 4px;
      border: solid 1px #eeeeee;
      cursor: pointer;
    }

    .to-login {
      display: block;
      text-align: center;
      margin: 15px 0 0;
      color: #009688;
    }
  }
}
</style>





